import { supabaseClient } from './supabaseClient.js';

// Hàm lấy danh sách Categories theo Loại Giao Dịch
export async function fetchCategories(txnType) {
    const { data, error } = await supabaseClient
        .from('categories')
        .select('*')
        .eq('type', txnType)
        .order('usage_count', { ascending: false });
    if (error) { console.error('[API] Lỗi Categories:', error.message); return []; }
    return data;
}

// Hàm lấy danh sách Tags theo Category ID
export async function fetchTags(categoryId) {
    const { data, error } = await supabaseClient
        .from('tags')
        .select('*')
        .eq('category_id', categoryId)
        .order('usage_count', { ascending: false });
    if (error) { console.error('[API] Lỗi Tags:', error.message); return []; }
    return data;
}

// 2. Tạo mới Category
export async function createCategory(name, type) {
    const { data, error } = await supabaseClient.from('categories').insert([{ name: name, type: type, usage_count: 1 }]).select().single();
    if (error) { console.error('[API] Lỗi tạo Category:', error.message); return null; }
    return data;
}

// 3. Tạo mới Tag
export async function createTag(name, categoryId) {
    const { data, error } = await supabaseClient.from('tags').insert([{ name: name, category_id: categoryId, usage_count: 1 }]).select().single();
    if (error) { console.error('[API] Lỗi tạo Tag:', error.message); return null; }
    return data;
}

// --- MANAGEMENT CRUD ---

export async function fetchAllCategories() {
    const { data, error } = await supabaseClient
        .from('categories')
        .select('*, tags(count)')
        .order('type')
        .order('name');
    if (error) { console.error('[API] Lỗi tải tất cả Categories:', error.message); return []; }
    return data;
}

export async function fetchAllTags() {
    const { data, error } = await supabaseClient
        .from('tags')
        .select('*, categories(name)')
        .order('name');
    if (error) { console.error('[API] Lỗi tải tất cả Tags:', error.message); return []; }
    return data;
}

export async function updateCategory(id, newName) {
    const { data, error } = await supabaseClient.from('categories').update({ name: newName }).eq('id', id).select().single();
    if (error) { console.error('[API] Lỗi sửa Category:', error.message); return null; }
    return data;
}

export async function deleteCategory(id) {
    // Xóa tất cả tags thuộc category trước (txns cũ vẫn giữ category_id cũ)
    await supabaseClient.from('tags').delete().eq('category_id', id);
    const { error } = await supabaseClient.from('categories').delete().eq('id', id);
    if (error) { console.error('[API] Lỗi xóa Category:', error.message); return false; }
    return true;
}

export async function fetchTagsByCategoryId(categoryId) {
    const { data, error } = await supabaseClient
        .from('tags')
        .select('*')
        .eq('category_id', categoryId)
        .order('name');
    if (error) { console.error('[API] Lỗi tải Tags:', error.message); return []; }
    return data;
}

export async function updateTag(id, newName) {
    const { data, error } = await supabaseClient.from('tags').update({ name: newName }).eq('id', id).select().single();
    if (error) { console.error('[API] Lỗi sửa Tag:', error.message); return null; }
    return data;
}

export async function deleteTag(id) {
    const { error } = await supabaseClient.from('tags').delete().eq('id', id);
    if (error) { console.error('[API] Lỗi xóa Tag:', error.message); return false; }
    return true;
}
